import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import InputLabel from "@mui/material/InputLabel";
import HelpIcon from "@mui/icons-material/Help";
import { FormDiv } from "../styles";
import { InputAdornment, FormHelperText } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import tooltipData from "../tooltip";
import { DatePicker } from "@mui/x-date-pickers-pro";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterMoment } from "@mui/x-date-pickers-pro/AdapterMoment";

const DateInput = styled(TextField)(({ theme }) => ({
  "label + &": {
    marginTop: theme.spacing(2.5),
  },
  "& .MuiInputBase-input": {
    borderRadius: 4,
    position: "relative",
    backgroundColor: theme.palette.mode === "light" ? "#fcfcfb" : "#2b2b2b",
    // border: '1px solid #ced4da',
    fontSize: 13.5,
    width: "100%",
    height: "1px",
    // padding: '7.5px 4px 8px 5px',
    transition: theme.transitions.create([
      "border-color",
      "background-color",
      "box-shadow",
    ]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "& .MuiInputBase-input": {
      padding: "7.5px 4px 7.5px 5px",
    },
    "&:disabled": {
      backgroundColor: "rgb(237 237 237)",
    },
  },
}));

const FormInput = (props) => {
  const {
    showHelpIcon,
    required,
    disabled,
    id,
    type,
    sx,
    placeholder,
    name,
    label,
    onChange,
    value,
    onBlur,
    errors,
    touched,
  } = props;

  return (
    <FormDiv>
      <FormControl className="form-control" variant="standard">
        <InputLabel
          className="input-label"
          shrink
          htmlFor={id}
          required={required}
        >
          {label}{" "}
          {showHelpIcon ? (
            <Tooltip title={tooltipData[id]} placement="top" arrow>
              <HelpIcon />
            </Tooltip>
          ) : (
            ""
          )}
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <DatePicker
            disableMaskedInput
            id={id}
            name={name}
            type={type}
            sx={sx}
            disabled={disabled}
            required={required}
            // InputProps={applyInputProps(inputProps)}
            placeholder={placeholder}
            onChange={onChange}
            value={value}
            onBlur={onBlur}
            format="DD MMM YYYY"
            toolbarPlaceholder={placeholder}
            // toolbarTitle="Select"
            renderInput={(params) => (
              <DateInput
                {...params}
                disabled={disabled}
                id={id}
                name={name}
                required={required}
              />
            )}
            // error={error}
          />
        </LocalizationProvider>
        {required && errors[id] && touched[id] ? (
          <FormHelperText
            id="my-helper-text"
            sx={{
              position: "absolute",
              alignSelf: "end",
              top: "50px",
              color: "red",
            }}
          >
            This field is {errors[id]}!
          </FormHelperText>
        ) : (
          ""
        )}
      </FormControl>
    </FormDiv>
  );
};

export default FormInput;
